import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Panel from 'react-bootstrap/lib/Panel'
import acc from 'accounting'

import SearchModalPayment from 'components/SearchModalPayment'
import { fetchLastOrno, fetchCollectionToday } from './actions'

class Payments extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openSearch: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.id !== this.props.params.id) {
      this.setState({
        openSearch: false,
      })
    }
  }

  _openSearch = () => {
    this.setState({
      openSearch: true,
    })
  }

  _hideSearch = () => {
    this.setState({
      openSearch: false,
    })
  }

  _renderSearch() {
    const { openSearch } = this.state

    if (!openSearch) {
      return null
    }

    return (
      <SearchModalPayment handleClose={this._hideSearch} />
    )
  }

  render() {
    const { children, __today } = this.props

    return (
      <div className="row">
        <div className="col-sm-9">
          { React.cloneElement(children, { onSearchForm: this._openSearch }) }
        </div>
        <div className="col-sm-3">
          <Panel header="Collections Today">
            <div className="text-center">
              <h3><small className="text-muted">Php</small> {acc.formatNumber(__today, 2)}</h3>
            </div>
          </Panel>
        </div>
        {this._renderSearch()}
      </div>
    )
  }
}

Payments.onEnter = (store) => () => {
  store.dispatch(fetchLastOrno())
  store.dispatch(fetchCollectionToday())
}

Payments.propTypes = {
  children: PropTypes.any,
  dispatch: PropTypes.func,
}

function mapStateToProps(state) {
  return {
    __today: state.payment.get('today'),
  }
}

export default connect(mapStateToProps)(Payments)



// WEBPACK FOOTER //
// ./src/containers/Payments/index.js